import { nothing } from 'lit';
import { IdentityDialogStrategy } from '../identity-verification-dialog.types';

export const NullIdentityStrategy: IdentityDialogStrategy = {
    renderContent: () => nothing,
    renderActions: () => nothing,
    validateAccountPassword: async () => ({
        success: true,
    }),
};
